export default "__VITE_ASSET__BRlex9oe__"